// i18n ligero ES/CAT. Sin dependencias.
// Uso: t('clave') o t('clave', { var: valor }) con placeholders {var}.

const TRANSLATIONS = {
  es: {
    'app.name': 'Querencia',
    'app.title': 'Querencia · El mapa de muchas rutas',
    'app.metaDesc': 'Querencia superpone muchas rutas GPX sobre un mapa para revelar la huella de quien conoce un territorio. Todo en tu navegador: sin cuentas, sin cookies, gratis.',
    'app.subtitle': 'El mapa de muchas rutas',
    'app.intro': 'Querencia nace de querer ver, de un vistazo, todos los caminos por los que ha pasado alguien que conoce bien un lugar.',

    'theme.light': 'Claro',
    'theme.dark': 'Oscuro',

    'drop.title': 'Arrastra GPX aquí',
    'drop.hint': 'o haz click para elegir archivos',
    'drop.explain': 'Sube de golpe todas las rutas (.gpx) de un mismo usuario y descubre por dónde se mueve quien conoce bien un lugar.',
    'drop.status.added': '{n} ruta(s) añadida(s)',
    'drop.status.skipped': '{n} ya estaba(n) cargada(s)',
    'drop.status.errors': '{n} archivo(s) con error',

    'map.fit': 'Encuadrar mis rutas',

    'zone.title': 'Zona de interés',
    'zone.tab.search': 'Buscar',
    'zone.tab.radius': 'Radio',
    'zone.tab.draw': 'Dibujar',
    'zone.search.placeholder': "Castellar de n'Hug, Berguedà, Parc Cadí…",
    'zone.radius.placeholder': 'Lugar central (Puigcerdà, Berga…)',
    'zone.radius.label': 'Radio:',
    'zone.radius.noCenter': 'Aún no has elegido centro',
    'zone.radius.center': 'Centro: {place}',
    'zone.draw.start': 'Empezar a dibujar',
    'zone.draw.drawing': 'Dibujando…',
    'zone.draw.hint': 'Click izquierdo para añadir vértices · Doble click o Enter para cerrar · Esc para cancelar',
    'zone.clear': 'Borrar zona',
    'zone.onlyInZone': 'Solo rutas que pasan por la zona',
    'zone.noPolygon': 'Ese lugar no tiene polígono ni área usable',

    'basemap.title': 'Mapa base',
    'basemap.topo.label': 'Topográfico',
    'basemap.topo.desc': 'OpenTopoMap · ideal para senderismo',
    'basemap.cyclosm.label': 'CyclOSM',
    'basemap.cyclosm.desc': 'Senderos y rutas ciclistas resaltadas',
    'basemap.satellite.label': 'Satélite',
    'basemap.satellite.desc': 'Esri World Imagery',
    'basemap.light.label': 'Claro',
    'basemap.light.desc': 'Minimal, las rutas brillan',
    'basemap.dark.label': 'Oscuro',
    'basemap.dark.desc': 'Estilo nocturno con neón suave',
    'basemap.blueprint.label': 'Blueprint',
    'basemap.blueprint.desc': 'Plano técnico azul',
    'basemap.constellation.label': 'Constelación',
    'basemap.constellation.desc': 'Sin mapa · solo tus rutas como estrellas',

    'stats.title': 'Estadísticas',
    'stats.routes': 'rutas',
    'stats.inZone': 'en zona',
    'stats.kmTotal': 'km total',
    'stats.kmZone': 'km zona',

    'owners.title': 'Propietarios',
    'owners.hint': 'Aparecen al cargar GPX',
    'owners.show': 'Click para mostrar',
    'owners.hide': 'Click para ocultar',
    'owners.imported': 'Importado',

    'tracks.title': 'Rutas cargadas',
    'tracks.empty': 'Aún no hay rutas cargadas',
    'tracks.clearAll': 'Limpiar rutas',
    'tracks.clearAll.confirm': '¿Limpiar las {n} rutas cargadas?',

    'export.all': '↓ Bajar como una sola ruta',
    'export.masterHint': 'La podrás usar como ruta master de ese territorio.',
    'export.zone.empty': '↓ En zona',
    'export.zone': '↓ En zona ({n})',
    'export.noTracks': 'No hay rutas que exportar con los filtros actuales',
    'export.name.owner': '{owner} · {n} rutas',
    'export.name.generic': 'Querencia · {n} rutas',
    'export.manifestHeader': 'Track de tracks · {n} rutas · creado con Querencia (querencia.zigiella.com)',

    'modal.title.one': '¿De quién es esta ruta?',
    'modal.title.many': '¿De quién son estas {n} rutas?',
    'modal.placeholder': 'Cristóbal · Mías · Anna…',
    'modal.hint': 'Se usará para etiquetar y colorear estas rutas. Si lo dejas vacío se marcarán como «Importado».',
    'modal.cancel': 'Cancelar carga',
    'modal.confirm': 'Confirmar',

    'search.searching': 'Buscando…',
    'search.noResults': 'Sin resultados',
    'search.error': 'Error al buscar',

    'footer.credits': '© OpenStreetMap · © OpenTopoMap (CC-BY-SA) · Geocoder: Nominatim',
    'footer.closing': 'Querencia es también conocer un territorio caminándolo, y explorándolo por donde otros caminaron.',
    'footer.privacy': 'Tus rutas nunca salen de tu navegador.',
    'footer.web': 'Un proyecto de',
    'footer.legalNotice': 'Aviso legal',
    'footer.privacyPolicy': 'Privacidad',
    'footer.coffee': 'Invítame a un café ☕',
    'footer.legal': 'Proyecto independiente, sin afiliación con Wikiloc ni con ningún proveedor de mapas. Usa solo archivos GPX que tengas derecho a usar.',
    'footer.analytics': 'Analítica sin cookies, respetuosa con tu privacidad (Simple Analytics).',
  },

  ca: {
    'app.name': 'Querència',
    'app.title': 'Querència · El mapa de moltes rutes',
    'app.metaDesc': "Querència superposa moltes rutes GPX sobre un mapa per revelar l'empremta de qui coneix un territori. Tot al teu navegador: sense comptes, sense galetes, gratis.",
    'app.subtitle': 'El mapa de moltes rutes',
    'app.intro': "Querència neix de voler veure, d'un cop d'ull, tots els camins per on ha passat algú que coneix bé un lloc.",

    'theme.light': 'Clar',
    'theme.dark': 'Fosc',

    'drop.title': 'Arrossega GPX aquí',
    'drop.hint': 'o fes clic per triar arxius',
    'drop.explain': "Puja de cop totes les rutes (.gpx) d'un mateix usuari i descobreix per on es mou qui coneix bé un lloc.",
    'drop.status.added': '{n} rutes afegides',
    'drop.status.skipped': '{n} ja estaven carregades',
    'drop.status.errors': '{n} arxius amb error',

    'map.fit': 'Enquadra les meves rutes',

    'zone.title': "Zona d'interès",
    'zone.tab.search': 'Cerca',
    'zone.tab.radius': 'Radi',
    'zone.tab.draw': 'Dibuixa',
    'zone.search.placeholder': "Castellar de n'Hug, Berguedà, Parc Cadí…",
    'zone.radius.placeholder': 'Lloc central (Puigcerdà, Berga…)',
    'zone.radius.label': 'Radi:',
    'zone.radius.noCenter': 'Encara no has triat centre',
    'zone.radius.center': 'Centre: {place}',
    'zone.draw.start': 'Comença a dibuixar',
    'zone.draw.drawing': 'Dibuixant…',
    'zone.draw.hint': 'Clic esquerre per afegir vèrtexs · Doble clic o Enter per tancar · Esc per cancel·lar',
    'zone.clear': 'Esborra zona',
    'zone.onlyInZone': 'Només rutes que passen per la zona',
    'zone.noPolygon': 'Aquest lloc no té polígon ni àrea utilitzable',

    'basemap.title': 'Mapa base',
    'basemap.topo.label': 'Topogràfic',
    'basemap.topo.desc': 'OpenTopoMap · ideal per a excursionisme',
    'basemap.cyclosm.label': 'CyclOSM',
    'basemap.cyclosm.desc': 'Senders i rutes ciclistes ressaltades',
    'basemap.satellite.label': 'Satèl·lit',
    'basemap.satellite.desc': 'Esri World Imagery',
    'basemap.light.label': 'Clar',
    'basemap.light.desc': 'Minimal, les rutes brillen',
    'basemap.dark.label': 'Fosc',
    'basemap.dark.desc': 'Estil nocturn amb neó suau',
    'basemap.blueprint.label': 'Blueprint',
    'basemap.blueprint.desc': 'Plànol tècnic blau',
    'basemap.constellation.label': 'Constel·lació',
    'basemap.constellation.desc': 'Sense mapa · només les teves rutes com estrelles',

    'stats.title': 'Estadístiques',
    'stats.routes': 'rutes',
    'stats.inZone': 'a la zona',
    'stats.kmTotal': 'km total',
    'stats.kmZone': 'km zona',

    'owners.title': 'Propietaris',
    'owners.hint': 'Apareixen en carregar GPX',
    'owners.show': 'Clic per mostrar',
    'owners.hide': 'Clic per amagar',
    'owners.imported': 'Importat',

    'tracks.title': 'Rutes carregades',
    'tracks.empty': 'Encara no hi ha rutes carregades',
    'tracks.clearAll': 'Neteja les rutes',
    'tracks.clearAll.confirm': 'Vols netejar les {n} rutes carregades?',

    'export.all': '↓ Baixar com una sola ruta',
    'export.masterHint': "La podràs fer servir com a ruta mestra d'aquest territori.",
    'export.zone.empty': '↓ A la zona',
    'export.zone': '↓ A la zona ({n})',
    'export.noTracks': 'No hi ha rutes per exportar amb els filtres actuals',
    'export.name.owner': '{owner} · {n} rutes',
    'export.name.generic': 'Querència · {n} rutes',
    'export.manifestHeader': 'Track de tracks · {n} rutes · creat amb Querència (querencia.zigiella.com)',

    'modal.title.one': 'De qui és aquesta ruta?',
    'modal.title.many': 'De qui són aquestes {n} rutes?',
    'modal.placeholder': 'Cristóbal · Meves · Anna…',
    'modal.hint': "S'usarà per etiquetar i acolorir aquestes rutes. Si ho deixes buit es marcaran com a «Importat».",
    'modal.cancel': 'Cancel·la la càrrega',
    'modal.confirm': 'Confirma',

    'search.searching': 'Cercant…',
    'search.noResults': 'Sense resultats',
    'search.error': 'Error en cercar',

    'footer.credits': '© OpenStreetMap · © OpenTopoMap (CC-BY-SA) · Geocodificació: Nominatim',
    'footer.closing': "Querència és també conèixer un territori caminant-lo, i explorant-lo per on altres van caminar.",
    'footer.privacy': 'Les teves rutes mai surten del teu navegador.',
    'footer.web': 'Un projecte de',
    'footer.legalNotice': 'Avís legal',
    'footer.privacyPolicy': 'Privacitat',
    'footer.coffee': "Convida'm a un cafè ☕",
    'footer.legal': 'Projecte independent, sense afiliació amb Wikiloc ni cap proveïdor de mapes. Fes servir només arxius GPX que tinguis dret a usar.',
    'footer.analytics': 'Analítica sense galetes, respectuosa amb la teva privacitat (Simple Analytics).',
  },
};

export const SUPPORTED = ['es', 'ca'];
const STORAGE_KEY = 'querencia.lang';
let current = detectLang();

function detectLang() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && SUPPORTED.includes(saved)) return saved;
  } catch {}
  const nav = (navigator.language || 'es').slice(0, 2).toLowerCase();
  return SUPPORTED.includes(nav) ? nav : 'es';
}

export function getLang() {
  return current;
}

export function setLang(lang) {
  if (!SUPPORTED.includes(lang)) return;
  current = lang;
  try { localStorage.setItem(STORAGE_KEY, lang); } catch {}
  if (typeof document !== 'undefined') document.documentElement.lang = lang;
}

export function t(key, vars) {
  const table = TRANSLATIONS[current] || TRANSLATIONS.es;
  let s = table[key] ?? TRANSLATIONS.es[key] ?? key;
  if (vars) {
    for (const k in vars) s = s.split(`{${k}}`).join(String(vars[k]));
  }
  return s;
}

// Aplica traducciones a elementos con data-i18n / data-i18n-placeholder.
export function applyStaticTranslations(root = document) {
  root.querySelectorAll('[data-i18n]').forEach((el) => {
    el.textContent = t(el.dataset.i18n);
  });
  root.querySelectorAll('[data-i18n-placeholder]').forEach((el) => {
    el.placeholder = t(el.dataset.i18nPlaceholder);
  });
  root.querySelectorAll('[data-i18n-empty]').forEach((el) => {
    el.dataset.emptyText = t(el.dataset.i18nEmpty);
  });
}
